export const ANALYTICS_OVERVIEW_URL = `/analytics/overview`
export const OLD_DASHBOARD_OVERVIEW_URL = `/dashboard`
export const ANALYTICS_PRODUCT_VIEWS_URL = `/analytics/product/product-views`
export const ANALYTICS_SALES_URL = `/analytics/product/sales`
export const ANALYTICS_ORDERS_URL = `/analytics/product/orders`
export const ANALYTICS_STORE_SALES_URL = `/analytics/product/store-sales`
export const ANALYTICS_DECLINED_ORDERS_URL = `/analytics/product/declined-orders`
export const ANALYTICS_CLICK_TO_SHIP_URL = `/analytics/product/click-to-ship`
export const ANALYTICS_RETURNS_URL = `/analytics/customer-insights/returns`
export const ANALYTICS_WISHLIST_URL = `/analytics/customer-insights/wishlist`
export const ANALYTICS_CONVERSION_RATE_URL = `/analytics/customer-insights/conversion-rate`

export const PRODUCT_LIST_OVERVIEW_URL = `/products`
export const PRODUCT_LIST_ACTIVE_URL = `/products/active`
export const PRODUCT_LIST_DRAFT_URL = `/products/draft`
export const PRODUCT_LIST_INACTIVE_URL = `/products/inactive`

export const PRODUCT_FORM_NEW = `/products/new`

export const ORDERS_NEW_URL = `/orders/new`
export const ORDERS_READY_TO_SHIP_URL = `/orders/ready-to-ship`
export const ORDERS_IN_TRANSIT_URL = `/orders/in-transit`
export const ORDERS_DELIVERED_URL = `/orders/delivered`

export const STOCK_LEVELS_ALL_URL = `/stock`
export const STOCK_LEVELS_ONLINE_URL = `/stock/online`
export const STOCK_LEVELS_STORE_URL = `/stock/in-store`

export const MARKETING_ASSETS_URL = `/marketing/assets`

export const REPORTS_SHIPPED_REVENUE_URL = `/reports/sales-report`
export const REPORTS_RETURNED_ORDERS_URL = `/reports/returned-orders`

export const BRANDS_CONTACT_FORM_URL = `https://contact.wolfandbadger.com/brands`

export const PAYMENT_CENTRE_URL = `/payment/`
